import request from './request'

export interface LearningStatItem {
  key: string
  label: string
  value: string
  icon?: string | null
  color?: string | null
  background?: string | null
}

export interface LearningRecordItem {
  id: number
  stage: string
  project: string
  time: string
  status: string
  status_class: string
  ai_suggestion: string
  user_feedback: string
  model_improvement: string
  module: string
  action?: string | null
}

export interface LearningInsightItem {
  title: string
  description: string
  points: string[]
  icon?: string | null
  color?: string | null
  background?: string | null
}

export interface LearningImprovementItem {
  title: string
  version: string
  description: string
  tags: string[]
  priority?: string | null
  agent_name?: string | null
}

export interface LearningSummaryResponse {
  stats: LearningStatItem[]
  records: LearningRecordItem[]
  insights: LearningInsightItem[]
  improvements: LearningImprovementItem[]
  last_updated: string
}

export const learningApi = {
  getSummary: () => request.get<LearningSummaryResponse>('/learning/summary'),
}